export default __webpack_public_path__ + "static/media/aimate-screenshot-04.51ea48a4.png";